import type { FC } from 'react';
import { useContext } from 'react';
import classnames from 'classnames';
import DaDreamupLogoAndText from '@wix/da-ds/pkg/DaDreamupLogoAndText';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useTranslation } from 'react-i18next';

import s from './ArtProtection.scss';

export interface Props {}

const ArtProtection: FC<Props> = () => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  return (
    <div className={classnames(s['root'], isMobile && s['on-phone'])}>
      {!isMobile && (
        <div className={s['left-section']}>
          <DaDreamupLogoAndText className={s['dreamup-logo']} />

          <div className={s['header']}>
            {t('packagePicker.artProtection.header')}
          </div>

          <div className={s['body']}>
            <div className={s['benefits-header']}>
              {t('packagePicker.artProtection.benefits')}
            </div>
            <ul className={s['benefits']}>
              <li>{t('packagePicker.artProtection.benefit-1')}</li>
              <li>{t('packagePicker.artProtection.benefit-2')}</li>
              <li>{t('packagePicker.artProtection.benefit-3')}</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};
ArtProtection.displayName = 'ArtProtection';

export default ArtProtection;
